import './mainTitle.css'
function MainTitle({children}){
    return <h2 className='main-title'>{children}</h2>
}
export default MainTitle